export default {
  nofund: {
    padgeTitle: '404',
    title: '404',
    summary: 'Sorry, page lost',
    btn: ['Back Home', 'Help Center']
  }
}
